var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      directives: [
        {
          name: "loading",
          rawName: "v-loading.body",
          value: _vm.loading,
          expression: "loading",
          modifiers: { body: true }
        }
      ]
    },
    [
      _c(
        "el-menu",
        {
          staticClass: "el-menu-demo",
          attrs: {
            "default-active": _vm.$route.path,
            mode: "horizontal",
            "background-color": "#545c64",
            "text-color": "#fff",
            "active-text-color": "#409EFF",
            router: ""
          }
        },
        [
          _c(
            "el-menu-item",
            { attrs: { index: "/home/wavepicking/wavepickinglist" } },
            [_vm._v("波次单列表")]
          ),
          _vm._v(" "),
          _c(
            "el-menu-item",
            { attrs: { index: "/home/aswavepicking/aswavepickinglist" } },
            [_vm._v("售后波次")]
          ),
          _vm._v(" "),
          _c(
            "el-menu-item",
            { attrs: { index: "/home/wavepicking/TempSummaryList/5" } },
            [_vm._v("质检汇总")]
          ),
          _vm._v(" "),
          _c(
            "el-menu-item",
            { attrs: { index: "/home/wavepicking/TempSummaryList/6" } },
            [_vm._v("改标汇总")]
          ),
          _vm._v(" "),
          _c(
            "el-menu-item",
            {
              attrs: { index: "/home/surpassSummary/surpassSummaryPickingList" }
            },
            [_vm._v("中分汇总拣货")]
          )
        ],
        1
      ),
      _vm._v(" "),
      _c("el-row", { staticClass: "tab-div" }, [
        _c(
          "div",
          { staticClass: "block" },
          [
            _c("span", { staticClass: "demonstration" }, [
              _vm._v("汇总状态统计：")
            ]),
            _vm._v(" "),
            _c("el-date-picker", {
              attrs: {
                type: "date",
                "value-format": "yyyy-MM-dd",
                placeholder: "选择日期时间"
              },
              model: {
                value: _vm.form2.fresh_date,
                callback: function($$v) {
                  _vm.$set(_vm.form2, "fresh_date", $$v)
                },
                expression: "form2.fresh_date"
              }
            }),
            _vm._v(" "),
            _c(
              "el-button",
              {
                staticStyle: { "margin-left": "auto" },
                attrs: { type: "primary", size: "mini" },
                on: {
                  click: function($event) {
                    return _vm.freshData()
                  }
                }
              },
              [_vm._v("刷新")]
            ),
            _vm._v(" "),
            _c(
              "el-tag",
              {
                staticClass: "tag-css",
                staticStyle: { "margin-left": "20px" }
              },
              [
                _vm._v(
                  "\n        商品数量（" +
                    _vm._s(_vm.countData.goods_num) +
                    "）"
                )
              ]
            ),
            _vm._v(" "),
            _c("el-tag", { staticClass: "tag-css" }, [
              _vm._v(
                "点货分离（" +
                  _vm._s(_vm.countData.quality_label_dabiao_num) +
                  "）"
              )
            ]),
            _vm._v(" "),
            _c("el-tag", { staticClass: "tag-css" }, [
              _vm._v("已拣货（" + _vm._s(_vm.countData.picking_num) + "）")
            ]),
            _vm._v(" "),
            _c("el-tag", { staticClass: "tag-css" }, [
              _vm._v("待拣货（" + _vm._s(_vm.countData.wait_picking_num) + "）")
            ]),
            _vm._v(" "),
            _c("el-tag", { staticClass: "tag-css" }, [
              _vm._v(
                "待生成拣货（" +
                  _vm._s(_vm.countData.wait_create_picking_num) +
                  "）"
              )
            ])
          ],
          1
        )
      ]),
      _vm._v(" "),
      _c(
        "el-row",
        { staticClass: "filter" },
        [
          _c(
            "el-col",
            [
              _c(
                "div",
                {
                  staticStyle: {
                    background: "#f3f3f3",
                    height: "30px",
                    "line-height": "30px",
                    padding: "0 25px",
                    display: "flex",
                    "align-items": "center"
                  }
                },
                [
                  _c("div", [_vm._v("筛选查询")]),
                  _vm._v(" "),
                  _c(
                    "el-button",
                    {
                      staticStyle: { "margin-left": "auto" },
                      attrs: {
                        type: "text",
                        icon: _vm.filterFold
                          ? "el-icon-arrow-down"
                          : "el-icon-arrow-up"
                      },
                      on: { click: _vm.toggleFilter }
                    },
                    [_vm._v(_vm._s(_vm.filterFold ? "展开筛选" : "收起筛选"))]
                  )
                ],
                1
              ),
              _vm._v(" "),
              _c("el-collapse-transition", [
                _c(
                  "div",
                  {
                    directives: [
                      {
                        name: "show",
                        rawName: "v-show",
                        value: !_vm.filterFold,
                        expression: "!filterFold"
                      }
                    ]
                  },
                  [
                    _c(
                      "div",
                      { staticStyle: { padding: "10px 25px" } },
                      [
                        _c(
                          "el-col",
                          { attrs: { span: 24 } },
                          [
                            _c(
                              "el-form",
                              {
                                staticClass: "demo-form-inline",
                                attrs: { inline: true, model: _vm.form }
                              },
                              [
                                _c(
                                  "el-form-item",
                                  { attrs: { label: "输入搜索：" } },
                                  [
                                    _c("el-input", {
                                      attrs: { placeholder: "汇总id" },
                                      nativeOn: {
                                        keyup: function($event) {
                                          if (
                                            !$event.type.indexOf("key") &&
                                            _vm._k(
                                              $event.keyCode,
                                              "enter",
                                              13,
                                              $event.key,
                                              "Enter"
                                            )
                                          ) {
                                            return null
                                          }
                                          return _vm.search.apply(
                                            null,
                                            arguments
                                          )
                                        }
                                      },
                                      model: {
                                        value: _vm.form.summary_id,
                                        callback: function($$v) {
                                          _vm.$set(_vm.form, "summary_id", $$v)
                                        },
                                        expression: "form.summary_id"
                                      }
                                    })
                                  ],
                                  1
                                ),
                                _vm._v(" "),
                                _c(
                                  "el-form-item",
                                  [
                                    _c("el-input", {
                                      attrs: { placeholder: "波次号" },
                                      nativeOn: {
                                        keyup: function($event) {
                                          if (
                                            !$event.type.indexOf("key") &&
                                            _vm._k(
                                              $event.keyCode,
                                              "enter",
                                              13,
                                              $event.key,
                                              "Enter"
                                            )
                                          ) {
                                            return null
                                          }
                                          return _vm.search.apply(
                                            null,
                                            arguments
                                          )
                                        }
                                      },
                                      model: {
                                        value: _vm.form.wave_picking_no,
                                        callback: function($$v) {
                                          _vm.$set(
                                            _vm.form,
                                            "wave_picking_no",
                                            $$v
                                          )
                                        },
                                        expression: "form.wave_picking_no"
                                      }
                                    })
                                  ],
                                  1
                                ),
                                _vm._v(" "),
                                _c(
                                  "el-form-item",
                                  [
                                    _c(
                                      "el-select",
                                      {
                                        attrs: { placeholder: "是否全部配齐" },
                                        model: {
                                          value: _vm.form.is_full_allot,
                                          callback: function($$v) {
                                            _vm.$set(
                                              _vm.form,
                                              "is_full_allot",
                                              $$v
                                            )
                                          },
                                          expression: "form.is_full_allot"
                                        }
                                      },
                                      _vm._l(_vm.is_full_allot, function(item) {
                                        return _c("el-option", {
                                          key: item.key,
                                          attrs: {
                                            label: item.name,
                                            value: item.key
                                          }
                                        })
                                      }),
                                      1
                                    )
                                  ],
                                  1
                                ),
                                _vm._v(" "),
                                _c(
                                  "el-form-item",
                                  [
                                    _c(
                                      "el-select",
                                      {
                                        attrs: {
                                          placeholder: "是否全部生成拣货任务"
                                        },
                                        model: {
                                          value: _vm.form.is_picking_full,
                                          callback: function($$v) {
                                            _vm.$set(
                                              _vm.form,
                                              "is_picking_full",
                                              $$v
                                            )
                                          },
                                          expression: "form.is_picking_full"
                                        }
                                      },
                                      _vm._l(_vm.is_picking_full, function(
                                        item
                                      ) {
                                        return _c("el-option", {
                                          key: item.key,
                                          attrs: {
                                            label: item.name,
                                            value: item.key
                                          }
                                        })
                                      }),
                                      1
                                    )
                                  ],
                                  1
                                ),
                                _vm._v(" "),
                                _c(
                                  "el-form-item",
                                  [
                                    _c(
                                      "el-select",
                                      {
                                        attrs: { placeholder: "是否已锁定" },
                                        model: {
                                          value: _vm.form.is_lock,
                                          callback: function($$v) {
                                            _vm.$set(_vm.form, "is_lock", $$v)
                                          },
                                          expression: "form.is_lock"
                                        }
                                      },
                                      _vm._l(_vm.is_lock, function(item) {
                                        return _c("el-option", {
                                          key: item.key,
                                          attrs: {
                                            label: item.name,
                                            value: item.key
                                          }
                                        })
                                      }),
                                      1
                                    )
                                  ],
                                  1
                                ),
                                _vm._v(" "),
                                _c(
                                  "el-form-item",
                                  [
                                    _vm.form.type == 5
                                      ? _c(
                                          "el-select",
                                          {
                                            attrs: {
                                              placeholder: "是否有备注"
                                            },
                                            model: {
                                              value: _vm.form.is_remark,
                                              callback: function($$v) {
                                                _vm.$set(
                                                  _vm.form,
                                                  "is_remark",
                                                  $$v
                                                )
                                              },
                                              expression: "form.is_remark"
                                            }
                                          },
                                          _vm._l(_vm.is_remark, function(item) {
                                            return _c("el-option", {
                                              key: item.key,
                                              attrs: {
                                                label: item.name,
                                                value: item.key
                                              }
                                            })
                                          }),
                                          1
                                        )
                                      : _vm._e()
                                  ],
                                  1
                                ),
                                _vm._v(" "),
                                _c(
                                  "el-form-item",
                                  [
                                    _vm.form.type == 5
                                      ? _c(
                                          "el-select",
                                          {
                                            attrs: {
                                              placeholder:
                                                "无备注汇总是否包含有备注波次"
                                            },
                                            model: {
                                              value:
                                                _vm.form.is_have_remark_wave,
                                              callback: function($$v) {
                                                _vm.$set(
                                                  _vm.form,
                                                  "is_have_remark_wave",
                                                  $$v
                                                )
                                              },
                                              expression:
                                                "form.is_have_remark_wave"
                                            }
                                          },
                                          _vm._l(
                                            _vm.is_have_remark_wave,
                                            function(item) {
                                              return _c("el-option", {
                                                key: item.key,
                                                attrs: {
                                                  label: item.name,
                                                  value: item.key
                                                }
                                              })
                                            }
                                          ),
                                          1
                                        )
                                      : _vm._e()
                                  ],
                                  1
                                ),
                                _vm._v(" "),
                                _c(
                                  "el-form-item",
                                  { attrs: { label: "创建时间：" } },
                                  [
                                    _c("el-date-picker", {
                                      attrs: {
                                        type: "datetimerange",
                                        "value-format": "yyyy-MM-dd HH:mm:ss",
                                        "range-separator": "至",
                                        "start-placeholder": "开始日期",
                                        "end-placeholder": "结束日期",
                                        "default-time": ["06:00:00", "06:00:00"]
                                      },
                                      model: {
                                        value: _vm.form.create_time,
                                        callback: function($$v) {
                                          _vm.$set(_vm.form, "create_time", $$v)
                                        },
                                        expression: "form.create_time"
                                      }
                                    })
                                  ],
                                  1
                                ),
                                _vm._v(" "),
                                _c(
                                  "el-form-item",
                                  { attrs: { label: "更新时间：" } },
                                  [
                                    _c("el-date-picker", {
                                      attrs: {
                                        type: "datetimerange",
                                        "value-format": "yyyy-MM-dd HH:mm:ss",
                                        "range-separator": "至",
                                        "start-placeholder": "开始日期",
                                        "end-placeholder": "结束日期",
                                        "default-time": ["06:00:00", "06:00:00"]
                                      },
                                      model: {
                                        value: _vm.form.update_time,
                                        callback: function($$v) {
                                          _vm.$set(_vm.form, "update_time", $$v)
                                        },
                                        expression: "form.update_time"
                                      }
                                    })
                                  ],
                                  1
                                ),
                                _vm._v(" "),
                                _c(
                                  "el-form-item",
                                  { attrs: { label: "最后配货时间：" } },
                                  [
                                    _c("el-date-picker", {
                                      attrs: {
                                        type: "datetimerange",
                                        "value-format": "yyyy-MM-dd HH:mm:ss",
                                        "range-separator": "至",
                                        "start-placeholder": "开始日期",
                                        "end-placeholder": "结束日期",
                                        "default-time": ["06:00:00", "06:00:00"]
                                      },
                                      model: {
                                        value: _vm.form.last_allot_time,
                                        callback: function($$v) {
                                          _vm.$set(
                                            _vm.form,
                                            "last_allot_time",
                                            $$v
                                          )
                                        },
                                        expression: "form.last_allot_time"
                                      }
                                    })
                                  ],
                                  1
                                ),
                                _vm._v(" "),
                                _c(
                                  "el-form-item",
                                  [
                                    _c(
                                      "el-button",
                                      {
                                        attrs: { type: "success" },
                                        on: { click: _vm.reset }
                                      },
                                      [_vm._v("重置")]
                                    )
                                  ],
                                  1
                                ),
                                _vm._v(" "),
                                _c(
                                  "el-form-item",
                                  [
                                    _c(
                                      "el-button",
                                      {
                                        attrs: { type: "success" },
                                        on: { click: _vm.search }
                                      },
                                      [_vm._v("查询")]
                                    )
                                  ],
                                  1
                                )
                              ],
                              1
                            )
                          ],
                          1
                        )
                      ],
                      1
                    )
                  ]
                )
              ])
            ],
            1
          )
        ],
        1
      ),
      _vm._v(" "),
      !_vm.loading
        ? _c(
            "el-row",
            [
              _c(
                "el-col",
                { staticStyle: { border: "1px solid #ddd" } },
                [
                  _c(
                    "el-row",
                    {
                      staticStyle: {
                        background: "#f3f3f3",
                        height: "50px",
                        "line-height": "30px",
                        padding: "0 25px",
                        display: "flex",
                        "align-items": "center"
                      },
                      attrs: { span: 24 }
                    },
                    [
                      _c("el-col", { attrs: { span: 8 } }, [
                        _vm._v("数据列表：")
                      ]),
                      _vm._v(" "),
                      _c(
                        "el-col",
                        {
                          staticStyle: { "text-align": "right" },
                          attrs: { span: 16 }
                        },
                        [
                          _vm.form.type == 6
                            ? _c(
                                "el-button",
                                {
                                  staticStyle: { "margin-left": "auto" },
                                  attrs: { type: "danger", size: "mini" },
                                  on: { click: _vm.printAll }
                                },
                                [_vm._v("打印配货单")]
                              )
                            : _vm._e(),
                          _vm._v(" "),
                          _c(
                            "el-dropdown",
                            {
                              staticStyle: { "margin-left": "10px" },
                              attrs: {
                                size: "mini",
                                "split-button": "",
                                type: "primary"
                              },
                              on: {
                                click: function($event) {
                                  return _vm.createTask(0)
                                },
                                command: _vm.createTask
                              }
                            },
                            [
                              _vm._v(
                                "\n            生成拣货任务\n            "
                              ),
                              _c(
                                "el-dropdown-menu",
                                {
                                  attrs: { slot: "dropdown" },
                                  slot: "dropdown"
                                },
                                [
                                  _c(
                                    "el-dropdown-item",
                                    { attrs: { command: "1" } },
                                    [_vm._v("全部生成拣货任务")]
                                  )
                                ],
                                1
                              )
                            ],
                            1
                          ),
                          _vm._v(" "),
                          _c(
                            "el-button",
                            {
                              staticStyle: { "margin-left": "10px" },
                              attrs: { type: "danger", size: "mini" },
                              on: {
                                click: function($event) {
                                  return _vm.lockSummary()
                                }
                              }
                            },
                            [_vm._v("锁定汇总")]
                          ),
                          _vm._v(" "),
                          _c(
                            "el-button",
                            {
                              attrs: { type: "primary", size: "mini" },
                              on: {
                                click: function($event) {
                                  return _vm.output(1)
                                }
                              }
                            },
                            [_vm._v("\n            导出")]
                          ),
                          _vm._v(" "),
                          _c(
                            "el-button",
                            {
                              attrs: { type: "primary", size: "mini" },
                              on: {
                                click: function($event) {
                                  return _vm.output(2)
                                }
                              }
                            },
                            [_vm._v("\n            导出明细")]
                          )
                        ],
                        1
                      )
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _vm.resData
                    ? _c(
                        "div",
                        { staticStyle: { "margin-bottom": "0" } },
                        [
                          _c(
                            "el-table",
                            {
                              directives: [
                                {
                                  name: "loading",
                                  rawName: "v-loading",
                                  value: _vm.tableLoading,
                                  expression: "tableLoading"
                                }
                              ],
                              ref: "multipleTable",
                              staticStyle: { width: "100%" },
                              attrs: {
                                height: "600",
                                data: _vm.resData.data,
                                "tooltip-effect": "dark"
                              },
                              on: {
                                "selection-change": _vm.handleSelectionChange
                              }
                            },
                            [
                              _c("el-table-column", {
                                attrs: {
                                  align: "right",
                                  type: "selection",
                                  width: "55"
                                }
                              }),
                              _vm._v(" "),
                              _c("el-table-column", {
                                attrs: {
                                  prop: "quality_label_summary_id",
                                  label: "汇总id"
                                }
                              }),
                              _vm._v(" "),
                              _c("el-table-column", {
                                attrs: {
                                  prop: "quality_label_goods_num",
                                  label: "分离数",
                                  align: "center"
                                }
                              }),
                              _vm._v(" "),
                              _c("el-table-column", {
                                attrs: {
                                  prop: "picking_goods_num",
                                  label: "已拣数量",
                                  align: "center"
                                }
                              }),
                              _vm._v(" "),
                              _c("el-table-column", {
                                attrs: {
                                  prop: "goods_num",
                                  label: "所需数量",
                                  width: "120",
                                  align: "center"
                                }
                              }),
                              _vm._v(" "),
                              _c("el-table-column", {
                                attrs: {
                                  prop: "today_full_allot_wave_num",
                                  label: "今日配齐波次数",
                                  "show-overflow-tooltip": "",
                                  align: "center"
                                }
                              }),
                              _vm._v(" "),
                              _c("el-table-column", {
                                attrs: {
                                  prop: "full_allot_wave_num",
                                  label: "配齐波次数量",
                                  "show-overflow-tooltip": "",
                                  align: "center"
                                }
                              }),
                              _vm._v(" "),
                              _c("el-table-column", {
                                attrs: {
                                  prop: "wave_num",
                                  label: "波次数量",
                                  "show-overflow-tooltip": "",
                                  align: "center"
                                }
                              }),
                              _vm._v(" "),
                              _c("el-table-column", {
                                attrs: {
                                  prop: "create_time",
                                  label: "生成时间",
                                  "show-overflow-tooltip": "",
                                  align: "center"
                                }
                              }),
                              _vm._v(" "),
                              _c("el-table-column", {
                                attrs: {
                                  prop: "update_time",
                                  label: "更新时间",
                                  "show-overflow-tooltip": "",
                                  align: "center"
                                }
                              }),
                              _vm._v(" "),
                              _c("el-table-column", {
                                attrs: {
                                  prop: "last_allot_time",
                                  label: "最后配货时间",
                                  "show-overflow-tooltip": "",
                                  align: "center"
                                }
                              }),
                              _vm._v(" "),
                              _c("el-table-column", {
                                attrs: {
                                  prop: "is_full_allot",
                                  label: "是否全部配齐",
                                  "show-overflow-tooltip": "",
                                  align: "center"
                                }
                              }),
                              _vm._v(" "),
                              _c("el-table-column", {
                                attrs: {
                                  prop: "is_picking_full",
                                  label: "是否全部生成拣货任务",
                                  "show-overflow-tooltip": "",
                                  align: "center"
                                }
                              }),
                              _vm._v(" "),
                              _c("el-table-column", {
                                attrs: {
                                  prop: "is_lock",
                                  label: "是否锁定",
                                  "show-overflow-tooltip": "",
                                  align: "center"
                                }
                              }),
                              _vm._v(" "),
                              _vm.form.type == 5
                                ? _c("el-table-column", {
                                    attrs: {
                                      prop: "is_remark",
                                      label: "是否有备注汇总",
                                      "show-overflow-tooltip": "",
                                      align: "center"
                                    }
                                  })
                                : _vm._e(),
                              _vm._v(" "),
                              _vm.form.type == 5
                                ? _c("el-table-column", {
                                    attrs: {
                                      prop: "is_have_remark",
                                      label: "无备注汇总是否包含有备注波次",
                                      "show-overflow-tooltip": "",
                                      align: "center"
                                    },
                                    scopedSlots: _vm._u(
                                      [
                                        {
                                          key: "default",
                                          fn: function(scope) {
                                            return [
                                              _c(
                                                "el-button",
                                                {
                                                  attrs: {
                                                    type: "text",
                                                    size: "small"
                                                  },
                                                  on: {
                                                    click: function($event) {
                                                      return _vm.handleClick(
                                                        scope.row
                                                      )
                                                    }
                                                  }
                                                },
                                                [
                                                  _vm._v(
                                                    _vm._s(
                                                      scope.row.is_have_remark
                                                    )
                                                  )
                                                ]
                                              )
                                            ]
                                          }
                                        }
                                      ],
                                      null,
                                      false,
                                      3456899062
                                    )
                                  })
                                : _vm._e(),
                              _vm._v(" "),
                              _c("el-table-column", {
                                attrs: {
                                  label: "操作",
                                  "show-overflow-tooltip": "",
                                  align: "center",
                                  width: "100"
                                },
                                scopedSlots: _vm._u(
                                  [
                                    {
                                      key: "default",
                                      fn: function(scope) {
                                        return [
                                          _c(
                                            "el-button",
                                            {
                                              attrs: {
                                                type: "text",
                                                size: "small"
                                              },
                                              on: {
                                                click: function($event) {
                                                  return _vm.opendeatail(
                                                    scope.row
                                                  )
                                                }
                                              }
                                            },
                                            [_vm._v("查看明细")]
                                          ),
                                          _c("br"),
                                          _vm._v(" "),
                                          _c(
                                            "el-button",
                                            {
                                              attrs: {
                                                type: "text",
                                                size: "small"
                                              },
                                              on: {
                                                click: function($event) {
                                                  return _vm.unlockSummary(
                                                    scope.row
                                                  )
                                                }
                                              }
                                            },
                                            [_vm._v("解锁汇总")]
                                          )
                                        ]
                                      }
                                    }
                                  ],
                                  null,
                                  false,
                                  2467834513
                                )
                              })
                            ],
                            1
                          )
                        ],
                        1
                      )
                    : _vm._e(),
                  _vm._v(" "),
                  _vm.resData
                    ? _c(
                        "div",
                        {
                          staticStyle: {
                            "text-align": "right",
                            padding: "25px"
                          }
                        },
                        [
                          _c("el-pagination", {
                            attrs: {
                              "current-page": _vm.resData.current_page,
                              background: "",
                              layout: "total, prev, pager, next, jumper ,sizes",
                              total: _vm.resData.total,
                              "page-size": _vm.form.pagesize,
                              "page-sizes": [20, 100, 500, 1000]
                            },
                            on: {
                              "update:currentPage": function($event) {
                                return _vm.$set(
                                  _vm.resData,
                                  "current_page",
                                  $event
                                )
                              },
                              "update:current-page": function($event) {
                                return _vm.$set(
                                  _vm.resData,
                                  "current_page",
                                  $event
                                )
                              },
                              "current-change": _vm.handleCurrentChange,
                              "size-change": _vm.handleSizeChange
                            }
                          })
                        ],
                        1
                      )
                    : _vm._e()
                ],
                1
              )
            ],
            1
          )
        : _vm._e()
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-66106475", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-66106475","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/pages/wavepicking/TempSummaryList.vue
// module id = null
// module chunks = 